import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

/** Identify the signed-in user on RUM and logs by Firebase uid only. */
export const setDatadogUser = (uid: string) => {
  datadogRum.setUser({ id: uid });
  datadogLogs.setUser({ id: uid });
};

export const clearDatadogUser = () => {
  datadogRum.clearUser();
  datadogLogs.clearUser();
};
